import CloudUtils from '../../utils/CloudUtils'

class AppRecommendService {
  async page(pageNo) {
    var result = null;
    try {
      result = await CloudUtils.post('/shuimujiaju-customer-api/app/recommend/list',{
        pageNo: pageNo,
        pageSize: 20
      })
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
  async get (id) {
    var result = null;
    try {
      result = await CloudUtils.post('/shuimujiaju-customer-api/app/recommend/get', { recommendId: id })
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new AppRecommendService()
